module.exports = __webpack_public_path__ + "media/coffee-preferences/country_of_origin_hawaii-888b99ab.png";